export default __webpack_public_path__ + "static/media/chatton8.5fd4ec8c.jpg";